/**
 * 实体类型枚举
 */
export enum EntityType {
    ZIPCODE = 'Zipcode',
    AREA = 'Area',
    WAREHOUSE = 'Warehouse'
}

/**
 * 关系类型枚举
 */
export enum RelationType {
    ZIPCODE_DSP_SORTINGCODE = 'ZIPCODE(DSP,SORTINGCODE)'
}

/**
 * 操作类型枚举
 */
export enum OperationType {
    CREATE = 1,
    UPDATE = 2,
    DELETE = 3
}

/**
 * 实体类型选项
 */
export const ENTITY_TYPE_OPTIONS = [
    { value: EntityType.ZIPCODE, label: 'central.relationLogs.entityTypes.zipcode' },
    { value: EntityType.AREA, label: 'central.relationLogs.entityTypes.area' },
    { value: EntityType.WAREHOUSE, label: 'central.relationLogs.entityTypes.warehouse' }
];

/**
 * 关系类型选项
 */
export const RELATION_TYPE_OPTIONS = [
    { value: RelationType.ZIPCODE_DSP_SORTINGCODE, label: 'central.relationLogs.relationTypes.zipcodeDspSortingcode' }
];

/**
 * 操作类型选项
 */
export const OPERATION_TYPE_OPTIONS = [
    { value: OperationType.CREATE, label: 'central.relationLogs.operationTypes.create' },
    { value: OperationType.UPDATE, label: 'central.relationLogs.operationTypes.update' },
    { value: OperationType.DELETE, label: 'central.relationLogs.operationTypes.delete' }
];